import { render } from "./Speakers.vue?vue&type=template&id=b437f302&scoped=true"
import script from "./Speakers.vue?vue&type=script&lang=js"
export * from "./Speakers.vue?vue&type=script&lang=js"

import "./Speakers.vue?vue&type=style&index=0&id=b437f302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b437f302"]])

export default __exports__